import React, { FC } from 'react'

import { alpha, useTheme } from '@mui/material'
import Box from '@mui/material/Box'

import chevronRightIcon from '../../assets/icons/chevronRightIcon.svg'
import { Direction } from '../../types'

export const ChevronButton: FC<{
  direction?: Direction
  onClick: () => void
  disabled?: boolean
}> = ({ direction = Direction.right, onClick, disabled }) => {
  const { spacing, palette } = useTheme()
  const directionStyleMap = {
    [Direction.left]: 'scaleX(-1)',
    [Direction.right]: 'none',
    [Direction.top]: 'rotate(-90deg)',
    [Direction.bottom]: 'rotate(90deg)',
  }

  return (
    <Box
      width={spacing(4)}
      height={spacing(4)}
      display="flex"
      justifyContent="center"
      alignItems="center"
      borderRadius="50%"
      onClick={() => {
        if (!disabled) {
          onClick()
        }
      }}
      aria-disabled={disabled}
      sx={{
        backgroundColor: palette.background.default,
        '&:hover': {
          cursor: disabled ? 'not-allowed' : 'pointer',
          backgroundColor: disabled
            ? alpha(palette.background.default, 0.7)
            : palette.background.default,
        },
      }}
    >
      <img
        src={chevronRightIcon}
        alt="move to"
        style={{ transform: directionStyleMap[direction], opacity: disabled ? '0.3' : '1' }}
      />
    </Box>
  )
}
